import lodash from 'lodash';
import { getPreUrl } from '../api/apis/onlineRepair';
import { getIpInfo } from '../api/apis/common';

import { ProductSelectType } from './enum';
import { seoConfig } from '../json';
import axios, { type InternalAxiosRequestConfig } from 'axios';
import { environmentData } from './baseInfo';
import { isReactive, isRef, toRaw } from 'vue';
import browserClient from '@apmplus/web';
import { REGION_MODE, ENV_MODE } from './config.js';

export function getAsyncData(data: any): any {
  return JSON.parse(JSON.stringify(data.value));
}

export function removeEmpty(obj: any) {
  const filteredObj = lodash.pickBy(obj, lodash.identity);
  return filteredObj;
}

export function isEmpty(val: any) {
  return lodash.isEmpty(val);
}

export function getTime(timestamp: any) {
  const date = new Date(timestamp);
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();

  const formattedDate = `${year}.${month > 9 ? month : `0${month}`}.${day > 9 ? day : `0${day}`}`;

  return formattedDate;
}

export function formatDate(value: any) {
  if (value == null) {
    return '';
  } else {
    const date = new Date(Number(value)); // 如果timestamp是数字，直接用于创建Date对象
    const year = date.getFullYear(); // 获取年份
    const month = ('0' + (date.getMonth() + 1)).slice(-2); // 获取月份，转为两位数
    const day = ('0' + date.getDate()).slice(-2); // 获取日，转为两位数
    const hours = ('0' + date.getHours()).slice(-2); // 获取小时，转为两位数
    const minutes = ('0' + date.getMinutes()).slice(-2); // 获取分钟，转为两位数

    return `${year}-${month}-${day} ${hours}:${minutes}`;
  }
}

export function isMobile() {
  var ua = navigator.userAgent,
    isWindowsPhone = /(?:Windows Phone)/.test(ua),
    isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
    isAndroid = /(?:Android)/.test(ua),
    isFireFox = /(?:Firefox)/.test(ua),
    isTablet =
      /(?:iPad|PlayBook)/.test(ua) ||
      (isAndroid && !/(?:Mobile)/.test(ua)) ||
      (isFireFox && /(?:Tablet)/.test(ua)),
    isPhone = /(?:iPhone)/.test(ua) && !isTablet,
    isPc = !isPhone && !isAndroid && !isSymbian && !isTablet,
    isHarmonyOS = /(?:HarmonyOS|Huawei)/.test(ua), // 新增判断鸿蒙系统
    isMobile = isAndroid || isPhone || isHarmonyOS;
  console.log('isMobile', isMobile);
  return isMobile;
}

// 获取重定向URL
export function redirectURL({ redirectPageMap = {}, baseURLMap = {}, locationHref = '' }) {
  let targetBaseURL = '';
  let currentBaseURL = '';
  for (const key of Object.keys(baseURLMap)) {
    if (locationHref.includes(key)) {
      currentBaseURL = key;
      targetBaseURL = baseURLMap[key as keyof object];
      break;
    }
  }
  if (isEmpty(targetBaseURL)) {
    return '';
  }

  const baseInfo = `${environmentData.country}-${environmentData.lang}/`;
  const locationData = locationHref.replace(`${currentBaseURL}${baseInfo}`, '').split('?');
  // 取路由和页面参数
  const [route, ...params] = locationData;
  const currentRoute = route || '/';
  const paramsString = params.join('?') || '';
  const targetRoute = redirectPageMap[currentRoute as keyof object] || '';

  const targetURL = `${targetBaseURL}${baseInfo}${targetRoute}?${paramsString}`;

  return targetURL;
}
export async function getCityInfo() {
  try {
    if (process.client) {
      const data: any = window.localStorage.getItem('cityinfo');

      if (typeof data !== 'undefined' && data !== null) return JSON.parse(data);
      const res: any = await getIpInfo();
      window.localStorage.setItem('cityinfo', JSON.stringify(res.data));
      return res.data;
    }
  } catch (error) {
    return {
      ip: '',
      country: '',
      province: '',
      city: ''
    };
  }
}
export function getDeviceInfo() {
  const ua = navigator.userAgent;
  let versionMatch = ua.match(/(Chrome|Firefox|MSIE|Edge|OPR|Safari|Trident)\/(\d+)/);
  let browserName = '';
  let browserVersion = '';
  if (versionMatch) {
    browserName = versionMatch[1];
    browserVersion = versionMatch[2];
  } else {
    console.log('无法获取浏览器版本信息');
  }
  return {
    browserName: browserName,
    browserVersion: browserVersion
  };
}
export function formatUrl(path: string, query: any) {
  return (
    path +
    '?' +
    Object.entries(query)
      .map(item => item.join('='))
      .join('&')
  );
}
// 获取中文的页面类型，用于埋点
export function getProductSelectPageType(type: ProductSelectType) {
  let pageType = '';
  switch (type) {
    case ProductSelectType.selfInspectManual:
      pageType = '自检手册';
      break;
    case ProductSelectType.selfRepair:
      pageType = '自助维修';
      break;
    case ProductSelectType.vehicleSupport:
      pageType = '车辆支持';
      break;
    case ProductSelectType.instructions:
      pageType = '说明书';
      break;
    case ProductSelectType.policyDetail:
      pageType = '政策详情';
      break;
    default:
      break;
  }
  return pageType;
}
// 选品页面的副标题，区分业务类型
export function getProductSelectPageDesc(type: ProductSelectType) {
  let pageDesc = '';
  switch (type) {
    case ProductSelectType.selfInspectManual:
      pageDesc = 'vehicleSupport.select_product_faq';
      break;
    case ProductSelectType.selfRepair:
      pageDesc = 'vehicleSupport.select_product_selfRepair';
      break;
    case ProductSelectType.vehicleSupport:
      pageDesc = 'vehicleSupport.select_product_vehicle';
      break;
    case ProductSelectType.instructions:
      pageDesc = 'vehicleSupport.select_product_instruction';
      break;
    case ProductSelectType.policyDetail:
      pageDesc = 'vehicleSupport.select_product_policy_service';
      break;
    default:
      break;
  }
  return pageDesc;
}
export function getProductBannerInfo(type: ProductSelectType) {
  let res = {
    desc: '',
    subDesc: '',
    imgM: '',
    imgPc: ''
  };
  switch (type) {
    case ProductSelectType.vehicleSupport:
      res.desc = 'support.product_support';
      res.subDesc = 'vehicleSupport.product_banner_support_desc';
      res.imgM = 'https://oms-oss-public.ninebot.com/website/support/support_banner_m.png';
      res.imgPc = 'https://oms-oss-public.ninebot.com/website/support/support_banner_pc.png';
      break;
    case ProductSelectType.instructions:
      res.desc = 'support.instruction';
      res.subDesc = 'vehicleSupport.product_banner_instruction_desc';
      res.imgM = 'https://oms-oss-public.ninebot.com/website/support/instructions_banner_m.png';
      res.imgPc = 'https://oms-oss-public.ninebot.com/website/support/instructions_banner_pc.png';
      break;
    case ProductSelectType.policyDetail:
      res.desc = 'support.policy_detail';
      res.subDesc = 'vehicleSupport.product_banner_policy_desc';
      res.imgM = 'https://oms-oss-public.ninebot.com/website/support/policy_banner_m.png';
      res.imgPc = 'https://oms-oss-public.ninebot.com/website/support/policy_banner_pc.png';
      break;
    case ProductSelectType.selfInspectManual:
      res.desc = 'support.frequently_asked_question';
      res.subDesc = 'vehicleSupport.product_banner_faqs_desc';
      res.imgM = 'https://oms-oss-public.ninebot.com/website/support/faq_banner_m.png';
      res.imgPc = 'https://oms-oss-public.ninebot.com/website/support/faq_banner_pc.png';
      break;
    case ProductSelectType.selfRepair:
      res.desc = 'support.spare_parts_repair_video';
      res.subDesc = 'vehicleSupport.product_banner_selfRepair_desc';
      res.imgM = 'https://oms-oss-public.ninebot.com/website/support/selfRepair_banner_m.png';
      res.imgPc = 'https://oms-oss-public.ninebot.com/website/support/selfRepair_banner_pc.png';
      break;
    default:
      break;
  }
  return res;
}

// 选品页面的SEO, 区分业务类型
export function getProductSelectPageSeo(type: ProductSelectType) {
  const { productSelectSeo } = seoConfig();
  return productSelectSeo[type];
}

/**
 *
 * @param file File
 * @returns fileKey 文件key
 */
export function uploadFile(file: File) {
  return new Promise(async (resolve, reject) => {
    const { type, name, uid } = file;
    const res: any = await getPreUrl({
      fileName: name,
      type: 18
    });
    const { display } = res.data;
    if (display == 'aws_s3') {
      const { key, presignedUrl } = res.data['awsS3'];
      // 上传文件
      const instance = axios.create({});
      const config = {
        headers: {
          'Content-Type': type
        }
      };
      const uploadRes = await instance.put(presignedUrl, file, config);

      if (uploadRes.status == 200) {
        resolve({
          fileKey: key,
          fileName: name
        });
      } else {
        reject({
          msg: uploadRes.data
        });
      }
    } else {
      reject({
        msg: '不支持该上传方式'
      });
    }
  });
}
// 识别链接
export function formatText(txt: string) {
  const reg = /https?:\/\/(?:www\.)?[^\s/$.?#].[^\s]*/g;
  let result = txt.replace(reg, function (item) {
    return "<a href='" + item + "' target='_blank' class='text-link'>" + item + '</a>';
  });
  return result;
}
export function getWeekDay() {
  var date = new Date();
  var dayOfWeek = date.getDay();
  const weekMap: any = {};
  switch (dayOfWeek) {
    case 0:
      weekMap.cnText = '周日';
      weekMap.usText = 'Sunday';
      break;
    case 1:
      weekMap.cnText = '周一';
      weekMap.usText = 'Monday';
      break;
    case 2:
      weekMap.cnText = '周二';
      weekMap.usText = 'Tuesday';
      break;
    case 3:
      weekMap.cnText = '周三';
      weekMap.usText = 'Wednesday';
      break;
    case 4:
      weekMap.cnText = '周四';
      weekMap.usText = 'Thursday';
      break;
    case 5:
      weekMap.cnText = '周五';
      weekMap.usText = 'Friday';
      break;
    case 6:
      weekMap.cnText = '周六';
      weekMap.usText = 'Saturday';
      break;
  }
  weekMap.number = dayOfWeek;
  return weekMap;
}

// 在线维修和寄修服务用到的正则
export const letterNumberSlashRegReplace = /[^A-Za-z0-9\/]/g; //（数字字母和斜线） 设备号替换正则
export const letterNumberRegReplace = /[^A-Za-z0-9]/g; // （数字字母）服务号替换正则
export const numberRegReplace = /[^0-9]/g; // 验证码替换正则
export const ChineseReplace = /[\u4e00-\u9fa5]/g; // 中文替换正则
export const emailReg = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/; // 邮箱正则

export const initYiDun = (
  yiDunIns: Function,
  callback: Function,
  ele: String,
  lang: String = 'zh-CN'
) => {
  initNECaptchaWithFallback(
    {
      element: ele,
      captchaId: 'bfe30d613cfc4f4286a1e51f7a269da3',
      width: '320px',
      mode: 'popup',
      apiVersion: 2,
      popupStyles: {
        position: 'fixed',
        top: '20%'
      },
      lang: lang,
      onVerify: function (err: any, data: any) {
        /**
         * 第一个参数是err（Error的实例），验证失败才有err对象
         * 第二个参数是data对象，验证成功后的相关信息，data数据结构为key-value，如下：
         * {
         *   validate: 'xxxxx' // 二次验证信息
         * }
         **/
        if (err) return; // 当验证失败时，内部会自动refresh方法，无需手动再调用一次
        callback(data, err);
      }
    },
    function onload(instance: any) {
      yiDunIns(instance);
    },
    function onerror(err: any) {
      // console.warn(err);
    }
  );
};
export function openInNewTabWithParams(data: any) {
  if (data.path) {
    data.path = `/${environmentData.country}-${environmentData.lang}${data.path}`;
  }
  const router = useRouter();
  const resolvedRoute = router.resolve(data);
  // 打开新窗口并导航至生成的URL
  window.open(resolvedRoute.href, '_blank');
}
// 欧洲。德意西 四个站点，隐藏online chat按钮
export function showOnlineChat() {
  return !['eu', 'de', 'it', 'es', 'uk', 'fr'].includes(environmentData.country);
}
// 免责声明-除了美洲,亚太使用美式英语,其他站点使用欧式英语 
export function showDisclaimer() {
  return ['us', 'ap', 'au', 'tr', 'ru'].includes(environmentData.country);
}
// 亚太/澳洲/土耳其/俄罗斯客服标题和按钮显示不一样
export function isAsia() {
  return ['ap', 'au', 'tr', 'ru'].includes(environmentData.country);
}
//显示右下角客服按钮悬停内容的自定义营业时间
export function customizeTime() {
  return ['eu', 'uk', 'au', 'tr', 'ru'].includes(environmentData.country);
}

/**
 *
 * @param {Object|Array} obj
 */
export const clearObject = obj => {
  if (isRef(obj)) {
    // 如果是 ref，直接清空其值
    obj.value = Array.isArray(toRaw(obj.value)) ? [] : {};
  } else if (isReactive(obj)) {
    // 如果是 reactive 对象，遍历并清空所有属性
    Object.keys(toRaw(obj)).forEach(key => {
      if (typeof obj[key] === 'string') {
        obj[key] = ''; // 字符串属性置为空
      } else if (Array.isArray(obj[key])) {
        obj[key] = []; // 数组属性置为空数组
      } else if (typeof obj[key] === 'object' && obj[key] !== null) {
        obj[key] = {}; // 对象属性置为空对象
      } else {
        obj[key] = null; // 其他类型属性置为 null
      }
    });
  } else if (Array.isArray(obj)) {
    // 如果是数组，清空数组
    obj.length = 0;
  }
};

// 自定义日志上报
export function logEvent(extraCategories = {}, eventName = 'customLog', extraMetrics = {}) {
  browserClient('sendEvent', {
    name: eventName,
    metrics: {
      timestamp: Date.now(),
      ...extraMetrics
    },
    categories: {
      env: `${REGION_MODE}-${ENV_MODE}`,
      ...extraCategories
    }
  });
}